import * as React from "react";
import { PDFViewer } from "@progress/kendo-react-pdf-viewer";
import { LoadingPanel } from "../LoadComponent/Loader";
export const Pdfdocviewer = (props) => {
  return (
    <PDFViewer
      data={props.documentData}
      style={{
        height: 700,
      }}
      maxZoom={true}
      tools={[
        "pager",
        "spacer",
        "zoomInOut",
        "zoom",
        "spacer",
        "print",
        "download",
        "search",
      ]}
      onRenderLoader={() =>
        props.documentData != "" ? null : <LoadingPanel />
      }
    />
  );
};
